import ManagerView from "./ManagerView";

export default ManagerView